import BrowserBase64Support from './base64/BrowserBase64Support';
import ServerBase64Support from './base64/ServerBase64Support';

export default class Base64Helper {
  static decode(value: string): string {
    return this.supportClass.decode(value);
  }

  static encode(value: string): string {
    return this.supportClass.encode(value);
  }

  private static get supportClass() {
    if (typeof window != 'undefined') {
      return new BrowserBase64Support();
    } else {
      return new ServerBase64Support();
    }
  }
}
